<div class="lineage-page">
  <header class="toolbar" [class.collapsed]="isToolbarCollapsed">
    <div class="toolbar-inner" [class.hidden]="isToolbarCollapsed">
      <button class="btn primary back" (click)="goBack()" [title]="'lineage.backTooltip' | transloco">
        <svg viewBox="0 0 24 24" width="1rem" height="1rem" aria-hidden="true"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" /></svg>
        {{ 'lineage.back' | transloco }}
      </button>

      <div class="control-group column-controls">
        <button class="btn-small btn-expand"
                (click)="expandAllNodes()"
                [title]="'lineage.expandAllTooltip' | transloco">
          <svg viewBox="0 0 24 24" width="14px" height="14px" aria-hidden="true">
            <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
          </svg>
          {{ 'lineage.expandAll' | transloco }}
        </button>

        <button class="btn-small btn-collapse"
                (click)="collapseAllNodes()"
                [title]="'lineage.collapseAllTooltip' | transloco">
          <svg viewBox="0 0 24 24" width="14px" height="14px" aria-hidden="true">
            <path d="M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
          </svg>
          {{ 'lineage.collapseAll' | transloco }}
        </button>

        <button class="btn-small btn-show-links" [class.active]="isShowAllLinks" (click)="expandAllAndShowLinks()" [title]="'lineage.showAllLinksTooltip' | transloco">
          {{ 'lineage.showAllLinks' | transloco }}
        </button>
      </div>

      <div class="control-group">
        <label class="switch">
          <input type="checkbox" [checked]="isShowBI" (change)="toggleShowBI()" [attr.aria-label]="'lineage.showBI' | transloco">
          <span class="track"><span class="thumb"></span></span>
        </label>
        <div class="control-label">{{ 'lineage.showBI' | transloco }}</div>
      </div>

      <div class="control-group">
        <label class="switch">
          <input type="checkbox" [checked]="isShowUnknown" (change)="toggleShowUnknownObjects()">
          <span class="track"><span class="thumb"></span></span>
        </label>
        <div class="control-label">{{ 'lineage.showUnknown' | transloco }}</div>
      </div>

      <div class="control-group numeric">
        <div class="numeric-controls">
          <button type="button" class="numeric-btn" (click)="decrementBackward()" [title]="'lineage.backwardTooltip' | transloco">
            <svg width="1rem" height="1rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5303 5.46967C10.8232 5.76256 10.8232 6.23744 10.5303 6.53033L5.81066 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H5.81066L10.5303 17.4697C10.8232 17.7626 10.8232 18.2374 10.5303 18.5303C10.2374 18.8232 9.76256 18.8232 9.46967 18.5303L3.46967 12.5303C3.17678 12.2374 3.17678 11.7626 3.46967 11.4697L9.46967 5.46967C9.76256 5.17678 10.2374 5.17678 10.5303 5.46967Z" fill="currentColor"></path> </g></svg>
          </button>
          <input type="number" class="num" [title]="'lineage.backwardTooltip' | transloco" [(ngModel)]="nBackward" (change)="loadFromApiAndBuild()" min="0" appBlurOnEnter>
          <button type="button" class="numeric-btn" (click)="incrementBackward()" [title]="'lineage.backwardTooltip' | transloco">
            <svg width="1rem" height="1rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(180)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5303 5.46967C10.8232 5.76256 10.8232 6.23744 10.5303 6.53033L5.81066 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H5.81066L10.5303 17.4697C10.8232 17.7626 10.8232 18.2374 10.5303 18.5303C10.2374 18.8232 9.76256 18.8232 9.46967 18.5303L3.46967 12.5303C3.17678 12.2374 3.17678 11.7626 3.46967 11.4697L9.46967 5.46967C9.76256 5.17678 10.2374 5.17678 10.5303 5.46967Z" fill="currentColor"></path> </g></svg>
          </button>
        </div>
        <div class="control-label">{{ 'lineage.backward' | transloco }}</div>
      </div>

      <div class="control-group numeric">
        <div class="numeric-controls">
          <button type="button" class="numeric-btn" (click)="decrementForward()" [title]="'lineage.forwardTooltip' | transloco">
            <svg width="1rem" height="1rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5303 5.46967C10.8232 5.76256 10.8232 6.23744 10.5303 6.53033L5.81066 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H5.81066L10.5303 17.4697C10.8232 17.7626 10.8232 18.2374 10.5303 18.5303C10.2374 18.8232 9.76256 18.8232 9.46967 18.5303L3.46967 12.5303C3.17678 12.2374 3.17678 11.7626 3.46967 11.4697L9.46967 5.46967C9.76256 5.17678 10.2374 5.17678 10.5303 5.46967Z" fill="currentColor"></path> </g></svg>
          </button>
          <input type="number" class="num" [title]="'lineage.forwardTooltip' | transloco" [(ngModel)]="nForward" (change)="loadFromApiAndBuild()" min="0" appBlurOnEnter>
          <button type="button" class="numeric-btn" (click)="incrementForward()" [title]="'lineage.forwardTooltip' | transloco">
            <svg width="1rem" height="1rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(180)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5303 5.46967C10.8232 5.76256 10.8232 6.23744 10.5303 6.53033L5.81066 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H5.81066L10.5303 17.4697C10.8232 17.7626 10.8232 18.2374 10.5303 18.5303C10.2374 18.8232 9.76256 18.8232 9.46967 18.5303L3.46967 12.5303C3.17678 12.2374 3.17678 11.7626 3.46967 11.4697L9.46967 5.46967C9.76256 5.17678 10.2374 5.17678 10.5303 5.46967Z" fill="currentColor"></path> </g></svg>
          </button>
        </div>
        <div class="control-label">{{ 'lineage.forward' | transloco }}</div>
      </div>

      <!-- Zoom controls -->
      <div class="control-group">
        <label class="control-label">{{ 'lineage.zoom' | transloco }}</label>
        <button class="btn-small" (click)="zoomIn()" [title]="'lineage.zoomIn' | transloco">+</button>
        <button class="btn-small" (click)="zoomOut()" [title]="'lineage.zoomOut' | transloco">−</button>
      </div>

      <div class="spacer"></div>
    </div>
    <div class="legend-container">
      <button class="btn-small legend-btn" (mouseenter)="isLegend = true" (mouseleave)="isLegend = false">
        <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 7.75C11.3787 7.75 10.875 8.25368 10.875 8.875C10.875 9.28921 10.5392 9.625 10.125 9.625C9.71079 9.625 9.375 9.28921 9.375 8.875C9.375 7.42525 10.5503 6.25 12 6.25C13.4497 6.25 14.625 7.42525 14.625 8.875C14.625 9.83834 14.1056 10.6796 13.3353 11.1354C13.1385 11.2518 12.9761 11.3789 12.8703 11.5036C12.7675 11.6246 12.75 11.7036 12.75 11.75V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V11.75C11.25 11.2441 11.4715 10.8336 11.7266 10.533C11.9786 10.236 12.2929 10.0092 12.5715 9.84439C12.9044 9.64739 13.125 9.28655 13.125 8.875C13.125 8.25368 12.6213 7.75 12 7.75ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" fill="currentColor"></path>
        </svg>
      </button>
      <div *ngIf="isLegend" class="legend" (mouseenter)="isLegend = true" (mouseleave)="isLegend = false">
        <div class="legend-header">
          <strong>{{ 'lineage.legend.title' | transloco }}</strong>
        </div>
        <div class="legend-section">
          <div class="legend-item">
            <div class="legend-color" style="background: #F2EEFF; border: 2px solid #7855ED;"></div>
            <span>{{ 'lineage.legend.mainNode' | transloco }}</span>
          </div>
          <div class="legend-item">
            <div class="legend-color" style="background: #FFFFFF; border: 2px solid #E5E5E5;"></div>
            <span>{{ 'lineage.legend.regularNode' | transloco }}</span>
          </div>
          <div class="legend-item">
            <div class="legend-color" style="background: #ffebee; border: 2px solid red;"></div>
            <span>{{ 'lineage.legend.missingNode' | transloco }}</span>
          </div>
          <div class="legend-item">
            <div class="legend-color" style="background: #E3F2FD; border: 2px solid #2196F3;"></div>
            <span>{{ 'lineage.legend.biNode' | transloco }}</span>
          </div>
        </div>
        <div class="legend-section">
          <div class="legend-item">
            <div class="legend-color" style="background: #E8F5E9; border: 2px solid #4CAF50;"></div>
            <span>{{ 'lineage.legend.selectedColumn' | transloco }}</span>
          </div>
          <div class="legend-item">
            <div class="legend-color" style="background: #FFF3E0; border: 2px solid #FF9800;"></div>
            <span>{{ 'lineage.legend.directLink' | transloco }}</span>
          </div>
          <div class="legend-item">
            <div class="legend-color" style="background: #FDCDFF; border: 2px solid #FD4FFF;"></div>
            <span>{{ 'lineage.legend.indirectLink' | transloco }}</span>
          </div>
        </div>
        <div class="legend-section">
          <div class="legend-item">
            <div class="legend-line" style="background: #D0ADFF; height: 2px;"></div>
            <span>{{ 'lineage.legend.regularLink' | transloco }}</span>
          </div>
          <div class="legend-item">
            <div class="legend-line" style="background: #7855ED; height: 3px;"></div>
            <span>{{ 'lineage.legend.selectedLink' | transloco }}</span>
          </div>
        </div>
      </div>
    </div>
  </header>

  <main class="canvas-area" [class.toolbar-collapsed]="isToolbarCollapsed">
    <div #cyContainer class="cy-container"></div>

    <aside class="info-card" *ngIf="selectedNode || selectedParentInfo">
      <!-- Информация о выбранном узле -->
      <div *ngIf="selectedNode" class="info-section">
        <div class="info-header">
          <div class="title">{{ selectedNode.label }}</div>
          <div class="meta">{{ selectedNode.typeDS }}</div>
        </div>
        <div class="info-body">
          <div class="row"><strong>{{ 'lineage.columns' | transloco }}</strong> {{ selectedNode.columns?.length || 0 }}</div>
        </div>
      </div>

        <!-- Информация о выбранной линии -->
        <div *ngIf="selectedParentInfo" class="info-section">
          <div class="info-header">
            <div class="title" *ngIf="selectedParentInfo.type === 'chart'">{{ 'lineage.diagram' | transloco }}</div>
            <div class="title" *ngIf="selectedParentInfo.type !== 'chart'">{{ 'lineage.formedIn' | transloco }}</div>
            <div class="meta" *ngIf="selectedParentInfo.type !== 'chart'">{{ selectedParentInfo.type }}</div>
          </div>
          <div class="info-body">
            <div class="row" *ngIf="selectedParentInfo.schema"><strong>{{ 'lineage.schema' | transloco }}</strong> {{ selectedParentInfo.schema }}</div>
            <div class="row"><strong>{{ 'lineage.name' | transloco }}</strong> {{ selectedParentInfo.name }}</div>
          </div>
        </div>
    </aside>
  </main>
</div>

